import { render, staticRenderFns } from "./HardwareBlockEditorHome.vue?vue&type=template&id=605d6fc4&scoped=true&"
import script from "./HardwareBlockEditorHome.vue?vue&type=script&lang=js&"
export * from "./HardwareBlockEditorHome.vue?vue&type=script&lang=js&"
import style0 from "./HardwareBlockEditorHome.vue?vue&type=style&index=0&id=605d6fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d6fc4",
  null
  
)

export default component.exports